import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "first-register" }
const _hoisted_2 = { class: "first-register__container first-register-container" }
const _hoisted_3 = { class: "first-register-container-business__info register-business-info" }
const _hoisted_4 = { class: "first-register-container-input__info register-input-info" }
const _hoisted_5 = { class: "first-register__button-container register-button-container" }

import { computed, onMounted, ref } from 'vue';
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FirstRegister',
  props: {
    propString: { default: 'default string' }
  },
  emits: ["on-click-next", "on-click-back", "on-click-download-template", "on-click-register-setting"],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const isSelectedRegisterBusiness = ref(true);

const registerBusinessStyle = computed((): string => {
  return isSelectedRegisterBusiness.value ? 'first-register-container--selected' : 'first-register-container--not-selected';
});

const registerInputStyle = computed((): string => {
  return isSelectedRegisterBusiness.value ? 'first-register-container--not-selected' : 'first-register-container--selected';
});

const props = __props;

const emits = __emit;

/**
 * 戻るボタン（STOPSHIP: ここ、何するボタン？？？　とりあえずおいてるだけ）
 */
const onClickBackButton = () => {
  emits('on-click-back');
};

/**
 * 次へボタン
 */
const onClickNextButton = () => {
  emits('on-click-next', isSelectedRegisterBusiness.value);
};

/**
 * テンプレートダウンロードボタン
 */
const onClickDownloadTemplate = () => {
  emits('on-click-download-template');
};

/**
 * 登録設定ボタン
 */
const onClickRegisterSetting = () => {
  emits('on-click-register-setting');
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        for: "first-register-container-business-button",
        class: _normalizeClass(["first-register-container__business first-register-container-business", registerBusinessStyle.value])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_i18n_t, {
            class: "register-business-info__title i18n-break",
            keypath: '取引設定：タイトル',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_i18n_t, {
            class: "register-business-info__description i18n-break",
            keypath: '取引設定：本文',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", {
            class: "register-business-info__link-text",
            onClick: onClickDownloadTemplate
          }, [
            _createVNode(_component_i18n_t, {
              class: "i18n-break",
              keypath: '取引設定：リンクテキスト',
              tag: "span"
            }, {
              newLine: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("br", null, null, -1)
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_i18n_t, {
            class: "register-business-info__usage i18n-break",
            keypath: '取引設定：使用例',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "first-register-container-business-button",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isSelectedRegisterBusiness).value = $event)),
          class: "first-register-container-business__button",
          type: "radio",
          value: true
        }, null, 512), [
          [_vModelRadio, isSelectedRegisterBusiness.value]
        ])
      ], 2),
      _createElementVNode("label", {
        for: "first-register-container-input-button",
        class: _normalizeClass(["first-register-container__input first-register-container-input", registerInputStyle.value])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_i18n_t, {
            class: "register-input-info__title i18n-break",
            keypath: '数値設定：タイトル',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_i18n_t, {
            class: "register-input-info__description i18n-break",
            keypath: '数値設定：本文',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", {
            class: "register-input-info__link-text",
            onClick: onClickRegisterSetting
          }, [
            _createVNode(_component_i18n_t, {
              class: "i18n-break",
              keypath: '数値設定：リンクテキスト',
              tag: "span"
            }, {
              newLine: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("br", null, null, -1)
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_i18n_t, {
            class: "register-input-info__usage i18n-break",
            keypath: '数値設定：使用例',
            tag: "span"
          }, {
            newLine: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("br", null, null, -1)
            ])),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "first-register-container-input-button",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isSelectedRegisterBusiness).value = $event)),
          class: "first-register-container-input__button",
          type: "radio",
          value: false
        }, null, 512), [
          [_vModelRadio, isSelectedRegisterBusiness.value]
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextButton, {
        "button-style": 'btn-secondary',
        size: 'btn-md',
        "on-click": onClickBackButton,
        disabled: true,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：戻るボタン')), 1)
        ], undefined, true),
        _: 1
      }),
      _createVNode(TextButton, {
        "button-style": 'btn-primary',
        size: 'btn-md',
        "on-click": onClickNextButton,
        disabled: false,
        class: "bulk-action-button-container__export-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('初期設定：次へボタン')), 1)
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})